// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveFilters_wrapper__1vih3","item":"ActiveFilters_item__3BG8m"};